/* eslint-disable max-lines */
import InspectRecentEvents from './InspectRecentEvents';

export default InspectRecentEvents;
